// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__29gDn","clickedWithMouse":"MenuLabel_clickedWithMouse__2XX9W","isOpen":"MenuLabel_isOpen__1Z5jz"};